import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";

import { preferenceChecks, StorageService } from "../../../../routes/services/storage.service";
import { Uris } from "../../../../routes/services/Uris";
import { GlobalFunction } from "../../../../routes/services/globalFuntion";
import { SinglePreferenceCheck } from "../../../../routes/services/storage.service";

@Injectable({
  providedIn: "root"
})
export class MinMaxService {
  constructor(
    public storageService: StorageService,
    private http: HttpClient,
    public router: Router,
    public globalFunction: GlobalFunction
  ) {}

  patchParametricPreferenceChangefarm(
    farm_id: number,
    body: SinglePreferenceCheck
  ): Observable<preferenceChecks> {
    return this.http
      .patch<preferenceChecks>(
        `${Uris.PARAMETRIC_PREFERENCE}${farm_id}/change-farm/`,
        body,
        this.storageService.headers()
      )
      .pipe(
        map((resp: preferenceChecks) => {
          return resp;
        })
      );
  }

  patchParametricPreference(
    id: number,
    body: SinglePreferenceCheck,
    type: "PONDS" | "WATERWISE"
  ): Observable<preferenceChecks> {
    return this.http
      .patch<preferenceChecks>(
        `${Uris[type]}${id}/parametric-preference/`,
        body,
        this.storageService.headers()
      )
      .pipe(
        map((resp: preferenceChecks) => {
          return resp;
        })
      );
  }
  getNotificationPreference(): Observable<preferenceChecks> {
    return this.http
      .get<preferenceChecks>(
        `${Uris.SENSORNOTIFICATIONPREFERENCE}view/`,
        this.storageService.headers()
      )
      .pipe(
        map((resp: preferenceChecks) => {
          return resp;
        })
      );
  }
  getParametricPreference(query: string): Observable<preferenceChecks[]> {
    return this.http
      .get<preferenceChecks[]>(
        `${Uris.PARAMETRIC_PREFERENCE}${query}`,
        this.storageService.headers()
      )
      .pipe(
        map((resp: preferenceChecks[]) => {
          return resp;
        })
      );
  }
  getParametricPreferencePondWaterwise(
    id: number,
    type: "PONDS" | "WATERWISE"
  ): Observable<preferenceChecks> {
    return this.http
      .get<preferenceChecks>(
        `${Uris[type]}${id}/parametric-preference/`,
        this.storageService.headers()
      )
      .pipe(
        map((resp: preferenceChecks) => {
          return resp;
        })
      );
  }

  deleteParametricPreferences(
    id: number,
    type: "waterwise" | "ponds",
    query = ""
  ): Observable<preferenceChecks> {
    return this.http
      .delete<preferenceChecks>(
        Uris.API + type + `/${id}/parametric-preference/${query}`,
        this.storageService.headers()
      )
      .pipe(
        map((resp: preferenceChecks) => {
          return resp;
        })
      );
  }

  patchNotificationPreference(body: SinglePreferenceCheck): Observable<preferenceChecks> {
    return this.http
      .patch<preferenceChecks>(
        `${Uris.SENSORNOTIFICATIONPREFERENCE}change/`,
        body,
        this.storageService.headers()
      )
      .pipe(
        map((resp: preferenceChecks) => {
          return resp;
        })
      );
  }
}
